<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Pending Invoices</h3>
    </div>

    <!-- Card Toolbar -->
    <div class="card-toolbar">
      <!-- Copy SM# Button (shown when checkboxes are selected) -->
      <button *ngIf="selectedVehicles.length > 0"
              type="button"
              class="btn btn-sm btn-primary me-3"
              (click)="copySelectedStockNumbers()">
        <i class="ki-duotone ki-copy fs-3">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Copy SMJ# ({{ selectedVehicles.length }})
      </button>

      <!-- Search Input -->
      <div class="d-flex align-items-center position-relative me-3">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-4">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input type="text" class="form-control form-control-solid w-250px ps-12"
               placeholder="Search vehicles..."
               [(ngModel)]="searchTerm"
               (keyup.enter)="onSearch(searchTerm)" />
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="d-flex align-items-center justify-content-center">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Loading vehicles...
      </div>
    </div>

    <!-- No Data State -->
    <div *ngIf="!isLoading && vehicles.length === 0" class="text-center py-5">
      <div class="text-muted">No vehicles found</div>
    </div>

    <!-- Vehicles Table -->
    <div *ngIf="!isLoading && vehicles.length > 0" class="pending-invoices-table-container">
      <div class="table-responsive">
        <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 pending-invoices-table">
          <thead>
            <tr class="fw-bold text-muted bg-light">
              <!-- Sticky Checkbox + Stock Number Column -->
              <th class="sticky-column">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="isAllSelected()"
                      [indeterminate]="isIndeterminate()"
                      (change)="toggleSelectAll($event)" />
                  </div>
                  Stock Number
                </div>
              </th>
              <!-- Scrollable Columns -->
              <th class="text-nowrap">Agent Name</th>
              <th class="text-nowrap">Purchase Date</th>
              <th class="text-nowrap">Age</th>
              <th class="text-nowrap">Auction Name</th>
              <th class="text-nowrap">Lot No</th>
              <th class="text-nowrap">Yard Name</th>
              <th class="text-nowrap">Yard In Date</th>
              <th class="text-nowrap">Chassis No</th>
              <th class="text-nowrap">Model</th>
              <th class="text-nowrap">Purchase Price</th>
              <th class="text-nowrap">Bid Charge</th>
              <th class="text-nowrap">Land Transport</th>
              <th class="text-nowrap">AVG eus/pics/dh</th>
              <th class="text-nowrap">Stock URL</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let vehicle of vehicles; trackBy: trackByFn" class="vehicle-row">
              <!-- Sticky Checkbox + Stock Number Column -->
              <td class="sticky-column">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="isVehicleSelected(vehicle._id)"
                      (change)="toggleVehicleSelection(vehicle._id, $event)" />
                  </div>
                  <span class="fw-bold text-primary">{{ vehicle.car_no || '-' }}</span>
                </div>
              </td>
              <!-- Scrollable Columns -->
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ vehicle.sales_person?.name || '-' }}
                </span>
              </td>
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ formatDate(vehicle.created_at) }}
                </span>
              </td>
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ calculateAge(vehicle.yard_date) }}
                </span>
              </td>
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ vehicle.type || '-' }}
                </span>
              </td>
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ vehicle.lot_no || '-' }}
                </span>
              </td>
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ vehicle.yard_name || '-' }}
                </span>
              </td>
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ formatDate(vehicle.yard_date) }}
                </span>
              </td>
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ vehicle.vin_no || '-' }}
                </span>
              </td>
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ vehicle.name || '-' }}
                </span>
              </td>
              <td class="text-nowrap text-end">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ formatPrice(vehicle.price, 'JPY') }}
                </span>
              </td>
              <td class="text-nowrap text-end">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ formatPrice(vehicle.price, 'JPY') }}
                </span>
              </td>
              <td class="text-nowrap text-end">
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ formatPrice(vehicle.price, 'JPY') }}
                </span>
              </td>
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  -
                </span>
              </td>
              <td class="text-nowrap">
                <span class="text-dark fw-semibold d-block fs-7">
                  <a href="https://example.com/stock/{{ vehicle.car_no || vehicle._id }}" target="_blank" class="text-primary">
                    View Stock
                  </a>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoading && vehicles.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>
